import React, { useEffect, useRef, useState } from "react";
import classes from "./MessageForm.module.css";
import { useDispatch, useSelector } from "react-redux";
import { ConstUserGroupEnum } from "../../../../../models/ConstUserGroupEnum";
import { ObjectTypeEnum, ObjectTypeNamesEnum } from "../../../../../models/ObjectTypeEnum";
import { getCoursesData } from "../../../../../store/discipline-action";
import Modal from "../../../../UI/Modal";
import IconsSelect from "./IconsSelect";
import { messagesApi } from "../../../../../utils";
import { throwApiError } from "../../../../lms-shared/store/error-handling-actions";
import moment from "moment";
import MessageDetailsForm from "./MessageDetails";
import ScrollLTR from "../../../../lms-shared/UI/ScrollLTR";
import { selectDisciplinesCurrentYear } from "../../../../../store/discipline-slice";

const MessageForm = ({ onClose, onAdd, data, title, iconList, setIconList }) => {

    const { texts } = useSelector(state => state.translate);
    const disciplines = useSelector(state => selectDisciplinesCurrentYear(state));
    const [inputs, setInputs] = useState({});
    const [selectCourses, setSelectCourses] = useState([]);
    const [selectIcon, setSelectIcon] = useState();
    const dispatch = useDispatch();
    const componentMounted = useRef(true);
    const applicationId = useSelector(state => state.application.applicationId);

    useEffect(() => {
        if (!disciplines && applicationId)
            dispatch(getCoursesData());
        if (data) {
            setInputs({
                ...data,
                targetObjectType: ObjectTypeEnum[data.targetObjectType],
                expireDateFlag: data.expireDate && data.expireDate.getTime() !== new Date(null).getTime() ? true : false,
                view: data.expireDate && data.expireDate >= new Date() || !data.expireDate,
                link: data.contents && data.contents[Object.keys(data.contents)[0]].link,
                textHe: data.contents && data.contents.he?.text,
                textAr: data.contents && data.contents.ar?.text,
                textEn: data.contents && data.contents.en?.text,
            });

            if (ObjectTypeEnum[data.targetObjectType] == ObjectTypeEnum.Course) {
                setSelectCourses([data.targetObjectId]);
                setInputs(pre => ({ ...pre, targetObjectId: ConstUserGroupEnum.Student }))
            }
        }

    }, [applicationId])

    useEffect(() => {
        return () => {
            componentMounted.current = false;
        }
    }, [])

    const addIcon = (data) => {
        setIconList(pre => ([...pre, data]))
    }

    const handleChangeInput = (name, value) => {
        setInputs(pre => ({ ...pre, [name]: value }));
    }

    const saveMessage = () => {

        const contents = {};
        if (inputs.textHe)
            contents.he = JSON.stringify({ text: inputs.textHe, link: inputs.link })
        if (inputs.textAr)
            contents.ar = JSON.stringify({ text: inputs.textAr, link: inputs.link })
        if (inputs.textEn)
            contents.en = JSON.stringify({ text: inputs.textEn, link: inputs.link })

        let expiredDate = null

        if (inputs.view == 0) {
            expiredDate = moment(new Date(null)).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
        }
        else if (eval(inputs.expireDateFlag) && inputs.expireDate)
            expiredDate = moment(inputs.expireDate).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]")


        let data = {
            id: inputs.id,
            refObjectId: applicationId,
            refObjectType: ObjectTypeNamesEnum.Application,
            expiredDate: expiredDate,
            contents: contents,
            messageType: inputs.messageType?.id,
            targetObjectId: inputs.targetObjectId,
            targetObjectType: ObjectTypeNamesEnum.ConstUserGroup
        }

        let rangeData;
        if (!inputs.id && inputs.targetObjectId == ConstUserGroupEnum.Student && selectCourses.length > 0 && selectCourses.length != disciplines.length) {
            rangeData = selectCourses.map(sc => ({ ...data, targetObjectType: ObjectTypeNamesEnum.Course, targetObjectId: sc }))
        }

        const func = inputs.id ? "messagesUpdatePost" : rangeData ? "messagesAddRangePost" : "messagesAddPost";

        messagesApi[func]({ messageAddOrUpdateInput: rangeData ? rangeData : data }, (error, resdata, response) => {
            if (error) {
                dispatch(throwApiError({ userMessage: texts.genralErrorMessage, error: error, statusCode: response?.statusCode, message: "genralErrorMessage " + error.message, level: 2, component: "MessageForm", line: 116 }))
            } else {
                onClose()
                onAdd();
            }
        })


    }

    return <Modal title={title ? title : texts.newMessage} onClose={onClose} dropStyle={{ width: "539px", height: "554px" }} >
        <ScrollLTR dropStyle={{ height: "500px" }}>
            <div className={classes.MessageForm}>
                {!selectIcon ?
                    <MessageDetailsForm
                        iconList={iconList}
                        saveMessage={saveMessage}
                        handleChangeInput={handleChangeInput}
                        inputs={inputs}
                        setSelectCourses={setSelectCourses}
                        selectCourses={selectCourses}
                        setSelectIcon={setSelectIcon}
                        disciplines={disciplines} />
                    :
                    <IconsSelect
                        icons={iconList}
                        addIcon={addIcon}
                        onClose={() => setSelectIcon(false)}
                        onSelect={(id) => handleChangeInput("messageType", id)} />}
            </div>
        </ScrollLTR>
    </Modal>
}

export default MessageForm;